module.exports = __webpack_public_path__ + "img/c0a3f1d2-196a-43e9-8d96-909ad2e095f6.200230eb.png";